import { getTiposDocumento, getTiposInstEdu, getNacionalidades } from "../actions/parametroActions"
import { Mensaje } from "../../controls/Mensaje"
import { logErrors } from "../../logErrors"
import { listar_tipos_documento, listar_tipos_inst_edu, listar_nacionalidades } from "../../helpers/parametroHelper"
import { parametroTypes } from "../../types/parametroTypes"

export const getTiposDocumentoBD = () => {
    return async( dispatch ) => {
        try {
            dispatch( getTiposDocumento( [] ) )
            
            const response = await listar_tipos_documento( { PARAMETRO_PADRE_COD: '0100' } )
            //alert( response)
            if ( response.Validacion !== '' ){
                dispatch( { type: parametroTypes.TIPO_DOCUMENTO_GET_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            }
            else{
                dispatch( { type: parametroTypes.TIPO_DOCUMENTO_GET_COMPLETE, 
                    payload: response.Data } );
            }

        } catch ( e ) {
            //alert(e)
            dispatch( { type: parametroTypes.TIPO_DOCUMENTO_GET_ERROR, payload: [] } );
            const err = logErrors( e )
            // Mensaje( err.Message, err.Type )
            Mensaje( 'Se perdió la conexión 101.<br>Intente nuevamente por favor', err.Type )
        }
        
    }
}


export const getTiposInstEduBD = () => {
    return async( dispatch ) => {
        try {
            dispatch( getTiposInstEdu( [] ) )
            
            const response = await listar_tipos_inst_edu( { PARAMETRO_PADRE_COD: '0200' } )

            if ( response.Validacion !== '' ){
                dispatch( { type: parametroTypes.TIPO_INST_EDU_GET_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            }
            else{
                dispatch( { type: parametroTypes.TIPO_INST_EDU_GET_COMPLETE, 
                    payload: response.Data } );
            }

        } catch ( e ) {
            dispatch( { type: parametroTypes.TIPO_INST_EDU_GET_ERROR, payload: [] } );
            const err = logErrors( e )
            // Mensaje( err.Message, err.Type )
            Mensaje( 'Se perdió la conexión 3.<br>Intente nuevamente por favor', err.Type )
        }
        
    }
}


export const getNacionalidadesBD = () => {
    return async( dispatch ) => {
        try {
            dispatch( getNacionalidades( [] ) )
            
            const response = await listar_nacionalidades( { PARAMETRO_PADRE_COD: '0300' } )

            if ( response.Validacion !== '' ){
                dispatch( { type: parametroTypes.NACIONALIDAD_GET_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            }
            else{
                dispatch( { type: parametroTypes.NACIONALIDAD_GET_COMPLETE, 
                    payload: response.Data } );
            }

        } catch ( e ) {
            dispatch( { type: parametroTypes.NACIONALIDAD_GET_ERROR, payload: [] } );
            const err = logErrors( e )
            // Mensaje( err.Message, err.Type )
            Mensaje( 'Se perdió la conexión 2.<br>Intente nuevamente por favor', err.Type )
        }
        
    }
}

